import React from 'react';
import '../components/styles/wedding.css';

const Glam = () => {
  const pricingData = [
    { service: "Soft Glam", proArtist: 120,  },
    { service: "Prom", proArtist: 140, },
    { service: "Glam", proArtist: 140,  },
    
  
  ];

  const images = [
    "/Makeup29.jpg",
    "/makeup15.jpg",
    "/makeup18.jpg",
    "/makeup16.jpg",
    "/Makeup30.jpg",
    "/Makeup31.jpg",
    "/Makeup19.jpg",
    "/Makeup20.jpg",
  ];

  return (
    <div className="bridal-container">
      <h1>GLAM MAKEUP</h1>
      
      <div className="gallery">
        {images.map((src, index) => (
          <img key={index} src={src} alt={`Bridal Image ${index + 1}`} />
        ))}
      </div>

      <h2 className="rates-title">In-studio rates</h2>
      
      <div className="pricing-table">
        <table>
          <thead>
            <tr>
              <th className="service-column">In-Studio Bridal Services</th>
              <th>Lorren's Rates</th>
            </tr>
          </thead>
          <tbody>
            {pricingData.map((item, index) => (
              <tr key={index}>
                <td className="service-name">{item.service}</td>
                <td>${item.proArtist}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <style>{`
        .bridal-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
          font-family: Arial, sans-serif;
        }

        h1 {
          text-align: center;
          margin: 40px 0;
          font-size: 28px;
          letter-spacing: 2px;
          font-weight: normal;
        }

        .gallery {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 20px;
          margin-bottom: 50px;
        }

        .gallery img {
          width: 100%;
          height: 300px;
          object-fit: cover;
          border-radius: 4px;
        }

        .rates-title {
          text-align: center;
          font-size: 48px;
          margin: 40px 0;
          font-family: 'Brush Script MT', cursive;
        }

        .pricing-table {
          width: 100%;
          overflow-x: auto;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 30px;
        }

        th, td {
          padding: 15px;
          text-align: center;
          border-bottom: 1px solid #ddd;
        }

        th {
          background-color: #f8f8f8;
          font-weight: normal;
        }

        .service-name {
          text-align: left;
        }

        .service-column {
          text-align: left;
        }

        tr:hover {
          background-color: #f5f5f5;
        }

        @media (max-width: 768px) {
          .gallery {
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          }
          
          table {
            font-size: 14px;
          }
          
          th, td {
            padding: 10px;
          }
        }
      `}</style>
    </div>
  );
};

export default Glam;